import { useSelector } from "react-redux";
import BasicInfoForm from "./BasicInfoForm";
import { RootState } from "../../configureStore";
import { useEffect } from "react";
import { ConfigStepId } from "../../utils/configuration";

export interface ApplicantInfoParams {
}

interface ApplicantInfoFunctionParams extends ApplicantInfoParams {
    onContinue: () => void;
}

const ApplicantInfo = ({
    onContinue,
}: ApplicantInfoFunctionParams) => {
    const allDone = useSelector<RootState, boolean>(({ applicant }) => Object.values(applicant.applicant?.missingInfo ?? {}).every((v) => !v));

    useEffect(() => {
        if (allDone) onContinue();
    }, [allDone]);

    return (
        <div>
            <BasicInfoForm stepId={ConfigStepId.info} />
        </div>
    );
};

export default ApplicantInfo;
